import { Component, OnInit, ViewChild } from "@angular/core";
import { ModalDirective } from "ngx-bootstrap";
import { AuthService } from "../../../service/auth/auth.service";
import { CommonService } from "../../../service/common/common.service";
import { GtmService } from "../../../service/gtm/gtm.service";
import { Member } from "../../../service/member/member";
import { MemberService } from "../../../service/member/member.service";

@Component({
  selector: 'app-profile-modal',
  templateUrl: './profile-modal.component.html',
  styleUrls: ['./profile-modal.component.scss'],
  providers: [MemberService]
})
export class ProfileModalComponent implements OnInit {

  @ViewChild('modal') modal: ModalDirective;
  isModalShown: boolean = false;

  profileEventSubscription;

  profile: Member;

  constructor(private authService: AuthService,
    private memberService: MemberService,
    private commonService: CommonService,
    private gtmService: GtmService) {

    this.profileEventSubscription = this.commonService.profileEvent.subscribe(
      email => this.showModal(email)
    );

  }

  ngOnInit() {
  }

  ngOnDestroy() {
    this.profileEventSubscription.unsubscribe();
  }

  showModal(email: string) {
    this.profile = null;
    this.memberService.getProfile(email).subscribe(member => {
      this.profile = member;
      this.gtmService.viewProfileEvent();
    });
    this.isModalShown = true;
    this.modal.show();
  }

  onHide(): void {
    this.isModalShown = false;
  }

  onReport(email: string) {
    if (window.confirm('신고하시겠습니까?')) {
      this.memberService.report(email).subscribe(member => {
        window.alert('신고가 접수되었습니다.');
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/member/shared/profile-modal/profile-modal.component.ts